import type { ModalProps } from 'antd';

export const BUTTON_TEXT = 'Pacing Schedule';
export const DEFAULT_REMOVE_SCHEDULE_MODAL_PROPS: ModalProps = {
  cancelText: 'Cancel',
  okText: 'Confirm',
  title: 'Remove Custom Pacing Schedule',
};
export const REMOVE_SCHEDULE_BUTTON_TOOLTIP_MESSAGE =
  'Select at least one line item that has a custom pacing schedule.';
